import { render, staticRenderFns } from "./SectionStylePanel.vue?vue&type=template&id=5beaac70&scoped=true&"
import script from "./SectionStylePanel.vue?vue&type=script&lang=js&"
export * from "./SectionStylePanel.vue?vue&type=script&lang=js&"
import style0 from "./SectionStylePanel.vue?vue&type=style&index=0&id=5beaac70&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5beaac70",
  null
  
)

export default component.exports